import React, { useEffect, useState } from 'react';

function ScoreBoard({ onBack }) {
    const [scores, setScores] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Récupère les scores du backend (MongoDB) au montage du composant
        // Si l'API échoue, on affiche les scores du localStorage (fallback hors ligne)
        
        
        // Détecter l'environnement selon l'hôte
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const API_URL = isLocalhost
            ? 'http://localhost:3001/api/scores'
            : 'https://memory-game-test-technique-rodium.onrender.com/api/scores';
        
        fetch(API_URL)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Impossible de récupérer les scores');
                }
            })
            .then((data) => {
                // Le backend retourne {success: true, data: [...], count: N}
                setScores(data.data || []);
            })
            .catch((error) => {
                // Fallback sur localStorage en cas d'erreur réseau ou serveur
                const saved = JSON.parse(localStorage.getItem('scores')) || [];
                setScores(saved);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    function formatDate(d) {
        return new Date(d).toLocaleString('fr-FR', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    function formatTime(t) {
        return `${t}s`;
    }

    return (
        <div className="scoreboard-container">
            <h2>Meilleurs Scores</h2>

            {loading && <p>Chargement des scores...</p>}

            {!loading && scores.length === 0 && <p>Aucun score enregistré.</p>}

            <div className="score-list">
                {scores.map((score, index) => (
                    <div key={index} className="score-item">
                        <div className="rank">#{index + 1}</div>
                        <div className="score-content">
                            <p>
                                <strong>Pseudo :</strong> {score.pseudo}
                            </p>
                            <p>
                                <strong>Coups :</strong> {score.coups}
                            </p>
                            <p>
                                <strong>Temps :</strong> {formatTime(score.time)}
                            </p>
                            <p className="date">{formatDate(score.date)}</p>
                        </div>
                    </div>
                ))}
            </div>

            <button className="scoreboard-btn" onClick={onBack}>
                Retour
            </button>
        </div>
    );
}

export default ScoreBoard;
